import JSZip from "jszip";
import convertVTTtoSRT from "./convertVTTtoSRT";

const downloadCaptions = (format: "vtt" | "srt", subtitles: { text: string; language: string }[], fileName = "captions.zip") => {
  const zip = new JSZip();

  subtitles.forEach(subtitle => {
    const subtitleFilename = `${subtitle.language}.${format}`;
    const vttContent = subtitle.text;

    if (format === "vtt") {
      zip.file(subtitleFilename, new Blob([vttContent], { type: "text/vtt" }));
    } else {
      const subtitleSRTContent = convertVTTtoSRT(vttContent);
      zip.file(subtitleFilename, new Blob([subtitleSRTContent], { type: "text/srt" }));
    }
  });

  // Create the .zip file
  zip.generateAsync({ type: "blob" }).then(content => {
    const url = window.URL.createObjectURL(content);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  });
};

export default downloadCaptions;
